import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../apiClient';
import { Rental } from '../materials/rentals';

export interface DailyRental {
    _id: string;
    designation: string;
    activityId: string;
    rentalTypeId: Rental;
    state: number;
    isUsed: boolean;
    price?: number;
    priceType?: number;
    observations?: string;
    quantity: number;
    unitPrice?: number;
    isExposedToWeather?: boolean;
}

export interface DeleteDailyRentalResponse {
    message: string;
    data: DailyRental;
}
export interface DeleteDailyRentalQueries {
    deleteTransfers?: boolean;
}

export const deleteDailyRental = async (id: string, queries?: DeleteDailyRentalQueries): Promise<DeleteDailyRentalResponse> => {
    try {
        const response: AxiosResponse<DeleteDailyRentalResponse> = await apiClient.delete(`/daily-rentals/${id}`, { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

interface CreateDailyRentalResponse {
    message: string;
    data: DailyRental;
}

export interface CreateDailyRentalBody {
    activityId: string;
    rentalTypeId: string;
    designation: string;
    state: number;
    createTransfer?: boolean;
    price?: number;
    priceType?: number;
    observations?: string;
    isUsed?: boolean;
    unitPrice?: number;
    quantity?: number;
    isExposedToWeather?: boolean;
}

export const createDailyRental = async (body: CreateDailyRentalBody): Promise<CreateDailyRentalResponse> => {
    try {
        const response: AxiosResponse<CreateDailyRentalResponse> = await apiClient.post('/daily-rentals', body);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};

export interface DailyRentalResponse {
    message: string;
    data: DailyRental;
}
export interface UpdateDailyRentalBody {
    activityId?: string;
    rentalTypeId?: string;
    state?: number;
    designation?: string;
    createTransfer?: boolean;
    isUsed?: boolean;
    price?: number | null;
    priceType?: number | null;
    observations?: string;
    quantity?: number;
    unitPrice?: number | null;
    isExposedToWeather?: boolean;
}

export interface UpdateDailyRentalQueries {
    deleteTransfers?: boolean;
    syncTransfers?: boolean;
}

export const updateDailyRental = async (
    id: string,
    body: UpdateDailyRentalBody,
    queries?: UpdateDailyRentalQueries
): Promise<DailyRentalResponse> => {
    try {
        const response: AxiosResponse<DailyRentalResponse> = await apiClient.patch('/daily-rentals/' + id, body, { params: queries });
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            throw new Error(error.response.data.message);
        } else {
            throw new Error('An unexpected error occurred');
        }
    }
};
